import { render, staticRenderFns } from "./draggable-popup-desktop.vue?vue&type=template&id=55959911&scoped=true&"
import script from "./draggable-popup-desktop.vue?vue&type=script&lang=js&"
export * from "./draggable-popup-desktop.vue?vue&type=script&lang=js&"
import style0 from "./draggable-popup-desktop.vue?vue&type=style&index=0&id=55959911&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55959911",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VSpacer,VToolbar,VToolbarTitle,VTooltip})
